export default "__VITE_ASSET__DuJ07KiY__"